export var wordType;
(function (wordType) {
    wordType[wordType["WORD"] = 0] = "WORD";
    wordType[wordType["PROVERB"] = 1] = "PROVERB";
    wordType[wordType["COMPOUND_WORD"] = 2] = "COMPOUND_WORD";
})(wordType || (wordType = {}));
export class Word {
    constructor(word, type, description, detail) {
        this.word = word;
        this.type = type;
        this.description = description;
        this.detail = detail;
    }
    getDetailUrl() {
        const { word, type } = this;
        switch (type) {
            case wordType.COMPOUND_WORD:
                return `/detay/birlesik-kelime/${word}`;
            case wordType.PROVERB:
                return `/detay/atasozu/${word}`;
            case wordType.WORD:
            default:
                return `/detay/${word}`;
        }
    }
}
